"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keyCodes = void 0;
exports.useExitOnEscape = useExitOnEscape;
exports.useKeyOutside = useKeyOutside;
exports.useKeydown = useKeydown;
exports.useKeypress = useKeypress;
exports.useKeyup = useKeyup;
var _base = require("./base.functions");
const keyCodes = exports.keyCodes = Object.freeze({
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  SHIFT: 16,
  CTRL: 17,
  ALT: 18,
  PAUSE: 19,
  BREAK: 19,
  CAPS_LOCK: 20,
  ESCAPE: 27,
  PAGE_UP: 33,
  SPACE: 32,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40,
  PRINT_SCREEN: 44,
  INSERT: 45,
  DELETE: 46,
  ['0']: 48,
  ['1']: 49,
  ['2']: 50,
  ['3']: 51,
  ['4']: 52,
  ['5']: 53,
  ['6']: 54,
  ['7']: 55,
  ['8']: 56,
  ['9']: 57,
  A: 65,
  B: 66,
  C: 67,
  D: 68,
  E: 69,
  F: 70,
  G: 71,
  H: 72,
  I: 73,
  J: 74,
  K: 75,
  L: 76,
  M: 77,
  N: 78,
  O: 79,
  P: 80,
  Q: 81,
  R: 82,
  S: 83,
  T: 84,
  U: 85,
  V: 86,
  W: 87,
  X: 88,
  Y: 89,
  Z: 90,
  LEFT_WINDOW_KEY: 91,
  RIGHT_WINDOW_KEY: 92,
  SELECT_KEY: 93,
  NUMPAD_0: 96,
  NUMPAD_1: 97,
  NUMPAD_2: 98,
  NUMPAD_3: 99,
  NUMPAD_4: 100,
  NUMPAD_5: 101,
  NUMPAD_6: 102,
  NUMPAD_7: 103,
  NUMPAD_8: 104,
  NUMPAD_9: 105,
  MULTIPLY: 106,
  ADD: 107,
  SUBTRACT: 109,
  DECIMAL_POINT: 110,
  DIVIDE: 111,
  F1: 112,
  F2: 113,
  F3: 114,
  F4: 115,
  F5: 116,
  F6: 117,
  F7: 118,
  F8: 119,
  F9: 120,
  F10: 121,
  F11: 122,
  F12: 123,
  NUM_LOCK: 144,
  SCROLL_LOCK: 145,
  MY_COMPUTER: 182,
  // (multimedia keyboard)
  MY_CALCULATOR: 183,
  // (multimedia keyboard)
  SEMI_COLON: 186,
  EQUAL_SIGN: 187,
  COMMA: 188,
  DASH: 189,
  PERIOD: 190,
  FORWARD_SLASH: 191,
  OPEN_BRACKET: 219,
  BACK_SLASH: 220,
  CLOSE_BRACKET: 221,
  SINGLE_QUOTE: 222
});

/**
 * useKeyEvent
 *
 * @param {keydown|keyup|keypress} eventName KeyCode for keydown event
 * @param {number|string} keyCode KeyCode for keydown event
 * @param {function} handler Assigned Handler Function on keyCode
 * @param {Object} element the target of the event listener, will default to document if possible
 */
function useKeyEvent(eventName, keyCode, handler, element = null) {
  if (typeof keyCode === 'string') {
    keyCode = keyCodes[keyCode?.toUpperCase()];
  }
  function onKeyEvent(e) {
    if (e && e.keyCode === keyCode) {
      e.preventDefault();
      handler(e);
    }
  }
  (0, _base.useEventListener)(eventName, onKeyEvent, element);
}

/**
 * useKeydown
 *
 * @param {number|string} keyCode KeyCode for keydown event
 * @param {function} handler Assigned Handler Function on keyCode
 * @param {Object} element the target of the event listener, will default to document if possible
 */
function useKeydown(keyCode, handler, element = null) {
  useKeyEvent('keydown', keyCode, handler, element);
}

/**
 * useKeyUp
 *
 * @param {number|string} keyCode KeyCode for keydown event
 * @param {function} handler Assigned Handler Function on keyCode
 * @param {Object} element the target of the event listener, will default to document if possible
 */
function useKeyup(keyCode, handler, element = null) {
  useKeyEvent('keyup', keyCode, handler, element);
}

/**
 * useKeypress
 *
 * @param {number|string} keyCode KeyCode for keydown event
 * @param {function} handler Assigned Handler Function on keyCode
 * @param {Object} element the target of the event listener, will default to document if possible
 */
function useKeypress(keyCode, handler, element = null) {
  useKeyEvent('keypress', keyCode, handler, element);
}

/**
 * useExitOnEscape
 *
 * @param {function} handler Assigned Handler Function on Escape Key code: 27
 * @param {keydown|keyup|keypress} eventName event for handler
 */
function useExitOnEscape(handler, eventName = 'keydown') {
  useKeyEvent(eventName, keyCodes.ESCAPE, handler);
}

/**
 * useKeyOutside
 *
 * @param {number} element element whose contents are considered inside
 * @param {function} handler Assigned Handler Function on keyCode
 * @param {Object} container the target of the event listener, will default to document if possible
 * @param {keydown|keyup|keypress} eventName event for handler
 */
function useKeyOutside(element, handler, container = null, eventName = 'keydown') {
  const onKeyEvent = evt => {
    const targetIsOutside = element && evt.target !== element && !element.contains(evt?.target);
    if (targetIsOutside) {
      handler(evt);
    }
  };
  (0, _base.useEventListener)(eventName, onKeyEvent, container);
}